import * as types from '../constantes/project';

export const ProjectReducer = (state = {}, action) => {
  switch (action.type) {
    case types.PROJECT_REQUEST:
      return {
        loading: true,
      };

    case types.PROJECT_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.PROJECT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.PROJECT_RESET:
      return {};

    default:
      return state;
  }
};

export const GetProjectReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.GET_PROJECT_REQUEST:
      return {
        loading: true,
      };
    case types.GET_PROJECT_SUCESS:
      return {
        loading: false,
        listProjects: action.payload,
      };
    case types.GET_PROJECT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const SearchProjectReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.SEARCH_PROJECT_REQUEST:
      return {
        loading: true,
      };
    case types.SEARCH_PROJECT_SUCESS:
      return {
        loading: false,
        searchProject: action.payload,
      };
    case types.SEARCH_PROJECT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const UpdateProjectReducer = (state = {}, action) => {
  switch (action.type) {
    case types.UPDATE_PROJECT_REQUEST:
      return {
        loading: true,
      };

    case types.UPDATE_PROJECT_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.UPDATE_PROJECT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.UPDATE_PROJECT_RESET:
      return {};

    default:
      return state;
  }
};

export const DeleteProjectReducer = (state = {}, action) => {
  switch (action.type) {
    case types.DELETE_PROJECT_REQUEST:
      return {
        loading: true,
      };

    case types.DELETE_PROJECT_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.DELETE_PROJECT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.DELETE_PROJECT_RESET:
      return {};

    default:
      return state;
  }
};

export const SearchUserProjectReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.SEARCH_USER_PROJECT_REQUEST:
      return {
        loading: true,
      };
    case types.SEARCH_USER_PROJECT_SUCESS:
      return {
        loading: false,
        searchUserProject: action.payload,
      };
    case types.SEARCH_USER_PROJECT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const SearchProjectByMonthReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.SEARCH_PROJECT_BY_MONTH_REQUEST:
      return {
        loading: true,
      };
    case types.SEARCH_PROJECT_BY_MONTH_SUCESS:
      return {
        loading: false,
        searchProjectByMonth: action.payload,
      };
    case types.SEARCH_PROJECT_BY_MONTH_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    case types.SEARCH_PROJECT_BY_MONTH_RESET:
      return {};

    default:
      return state;
  }
};
